"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceSchemeType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var ServiceSchemeType_Factory = /** @class */ (function () {
    function ServiceSchemeType_Factory() {
    }
    ServiceSchemeType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            TypeId: model.TypeId,
            TypeName: model.TypeName,
        };
        return result;
    };
    ServiceSchemeType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            TypeId: model.TypeId,
            TypeName: model.TypeName,
        };
        return result;
    };
    return ServiceSchemeType_Factory;
}());
exports.ServiceSchemeType_Factory = ServiceSchemeType_Factory;
